import { Component, EventEmitter, Input, OnInit, Output, OnDestroy } from '@angular/core';
import * as _ from "underscore";
import { outwardFilter } from '../../../shared/classes/filter';
import { SortBy } from '../../../Enums/sortEnums';
import { OfficesService } from '../../../shared/services/offices.service';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { OutwardService } from '../../../shared/services/outward.service'; 

@Component({
  selector: 'app-outward-supervisor-filter',
  templateUrl: './outward-supervisor-filter.component.html',
  styleUrls: ['./outward-supervisor-filter.component.css']
})
export class OutwardSupervisorFilterComponent implements OnInit,OnDestroy {
  @Input() column;

  @Output() gridFiltersApplied = new EventEmitter();

  @Input() registrationArray;

  filteredData : any;

  @Input() tableSettings;

  @Input() statusArray;
  @Input() cityArray;
  @Input() officeArray;

  
  private unsubscribe$ =new Subject<void>();


  selectAllRegType: {isChecked: boolean} = {isChecked : true};
  selectAllStatusType: {isChecked: boolean} = {isChecked : true};
  selectAllFromType: {isChecked: boolean} = {isChecked : true};
  selectAllCityType: {isChecked: boolean} = {isChecked : true};
  selectAllOfficeType: {isChecked: boolean} = {isChecked : true};


  isUnSelectAll: boolean = false;
  
  constructor(private outwardService: OutwardService) { }

  ngOnInit() {

    this.outwardService.resetFilters
    .pipe(takeUntil(this.unsubscribe$))
    .subscribe(() => {   
         
      this.resetFilters();
      
      this.outwardService.resetHeaders.next();          
    });

    this.checkSelectAllFilter();
    this.checkFilterValue();
  }


  selectAllRegTypeFilter(check) {
    if (check) {
      this.registrationArray.forEach(item => {
        item.isCheck = true;
      })

    }
    else {
      this.registrationArray.forEach(item => {
        item.isCheck = false;
      })

    }
  }

  selectAllCityTypeFilter(check) {
    if (check) {
      this.cityArray.forEach(item => {
        item.isCheck = true;
      })
    }
    else {
      this.cityArray.forEach(item => {
        item.isCheck = false;
      })
    }
  }

  selectAllOfficeTypeFilter(check) {
    if (check) {
      this.officeArray.forEach(item => {
        item.isCheck = true;
      })
    }
    else {
      this.officeArray.forEach(item => {
        item.isCheck = false;
      })
    }
  }

  selectAllStatusFilter(check) {
    if (check) {
      this.statusArray.forEach(item => {
        item.isCheck = true;
      })


    }
    else {
      this.statusArray.forEach(item => {
        item.isCheck = false;
      })

    }
  }

  

  checkFilterValue(){

    if(outwardFilter.regTypeList.length == 0 && outwardFilter.regTypeList.indexOf('None') < 0){
      
      this.selectAllRegTypeFilter(true);
    }
    if(outwardFilter.statusList.length==0 && outwardFilter.statusList.indexOf('None')<0){
        this.selectAllStatusFilter(true);
    }
    if(outwardFilter.cityList.length == 0 && outwardFilter.cityList.indexOf('None') < 0){
      
      this.selectAllCityTypeFilter(true);
    }
    if(outwardFilter.officeList.length == 0 && outwardFilter.officeList.indexOf('None') < 0){
      
      this.selectAllOfficeTypeFilter(true);
    }
    
  }

  


  checkSelectAllFilter(){
    
    if(outwardFilter.regTypeList.length >0 || outwardFilter.regTypeList.indexOf('None') > -1){
  
      this.selectAllRegType.isChecked = false;
    }
    if(outwardFilter.statusList.length >0 || outwardFilter.statusList.indexOf('None') > -1){
  
      this.selectAllStatusType.isChecked = false;
    }
    if(outwardFilter.cityList.length > 0 && outwardFilter.cityList.indexOf('None') >-1){
      this.selectAllCityType.isChecked = false;
    }
    if(outwardFilter.officeList.length > 0 && outwardFilter.officeList.indexOf('None') >-1){
      this.selectAllOfficeType.isChecked = false;
    }
     
  }

      // Selection/unselection of filter options
  togglefilter(arrayType,selectAllValue,checked){
    
        var allTypeCount = arrayType.length;
        var checkedTypeCount = 0;
        arrayType.forEach(item => {
          if (item.isCheck) {              
            checkedTypeCount = checkedTypeCount + 1;
          }
        })

                  
        if(!checked){
          
            selectAllValue.isChecked = false;
        }
        else{
          if(allTypeCount == checkedTypeCount){
            selectAllValue.isChecked = true;
          }
          else{
            selectAllValue.isChecked = false;
          }
        }
  }

  checkSelectedRegType(arrayList,column){
    let selectedType =[];
    column.isFilterIcon = true;
    arrayList.forEach(item => {
      if (item.isCheck) {

        selectedType.push(item.name);

      }
    })


      if(selectedType.length == arrayList.length){
        outwardFilter.regTypeList = [];

      }
      else{
        return outwardFilter.regTypeList = selectedType;
      }
    
  }

  checkSelectedStatusType(arrayList,column){
    
    let selectedType =[];
    column.isFilterIcon = true;
    arrayList.forEach(item => {
      if (item.isCheck) {            
        selectedType.push(item.name);            
}
    })

    
      if(selectedType.length == arrayList.length){
        outwardFilter.statusList = [];
          //column.isFilterIcon = false;          
      }
      else{
        return outwardFilter.statusList = selectedType;
      }
    
  }
  
  checkSelectedFromType(arrayList,column){
    
    let selectedType =[];
    column.isFilterIcon = true;
    arrayList.forEach(item => {
      if (item.isCheck) {            
        selectedType.push(item.name);            
}
    })
  }

  checkSelectedCityType(arrayList,column){
    let selectedType =[];
    column.isFilterIcon = true;
    arrayList.forEach(item => {
      if (item.isCheck) {
        selectedType.push(item.name);
      }
    })


      if(selectedType.length == arrayList.length){
        outwardFilter.cityList = [];
      }
      else{
        return outwardFilter.cityList = selectedType;
      } 
  }

  checkSelectedOfficeType(arrayList,column){
    let selectedType =[];
    column.isFilterIcon = true;
    arrayList.forEach(item => {
      if (item.isCheck) {
        selectedType.push(item.name);
      }
    })

      if(selectedType.length == arrayList.length){
        outwardFilter.officeList = [];
      }
      else{
        return outwardFilter.officeList = selectedType;
      }
  }

  onFilterApply(column){

    this.isUnSelectAll = false;

    if(column.isResNameSortA) {
      column.sortOrder = 'Asc';
      
    }else if (column.isResNameSortD) {
      column.sortOrder = 'Desc';

    }else if (column.isResNameSortN) {
      column.sortOrder = '';
    
    }

    column.displaysort = false;
   
    if(column.sortBy == SortBy.Reg){          
      this.checkSelectedRegType(this.registrationArray,column);
    }
    if(column.sortBy == SortBy.Status){          
      this.checkSelectedStatusType(this.statusArray,column);
    }
    if(column.sortBy == SortBy.City){          
      this.checkSelectedCityType(this.cityArray,column);
    }
    if(column.sortBy == SortBy.Office){          
      this.checkSelectedOfficeType(this.officeArray,column);
    }
      
    if(!this.isUnSelectAll){
    column.isFilterApplied = true;
  
    this.gridFiltersApplied.emit(true);
    }

  }




  resetEvents(){
    this.tableSettings.columns.forEach(item => {
      item.displaysort = false;
    })
}

  resetFilters()
  {        
    this.selectAllRegTypeFilter(true);
    this.selectAllRegType.isChecked = true;   
    this.selectAllStatusFilter(true);
    this.selectAllStatusType.isChecked = true;   
    
    this.selectAllFromType.isChecked = true; 
    this.selectAllCityTypeFilter(true);
    this.selectAllCityType.isChecked = true;
    this.selectAllOfficeTypeFilter(true);
    this.selectAllOfficeType.isChecked = true;

  }
  ngOnDestroy(){
    this.unsubscribe$.next();
    this.unsubscribe$.complete();
  }
}
